/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DiscntMasterDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string;
    /**
     * 割引指定区分１：数字
     */
    discntSiteiDiv1?: string;
    /**
     * 割引指定区分２：数字
     */
    discntSiteiDiv2?: string;
    /**
     * 割引指定区分３：数字
     */
    discntSiteiDiv3?: string;
    /**
     * 割引指定区分４：数字
     */
    discntSiteiDiv4?: string;
    /**
     * 割引指定区分５：数字
     */
    discntSiteiDiv5?: string;
    /**
     * 割引範囲開始値：数字
     */
    discntRangeStart?: number;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 割引正式名称：全角
     */
    discntAname?: string;
    /**
     * 割引略称名称：全角
     */
    discntRyaku?: string;
    /**
     * 割引範囲終了値：数字
     */
    discntRangeEnd?: number;
    /**
     * 割引タイプコード：数字<br>　画面項目ID＝\'C011553\'
     */
    discntType?: string;
    /**
     * 割引タイプコード（名称）：全半角混在
     */
    discntTypeAname?: string;
    /**
     * 割引対象料金下限額：数字
     */
    discntTargetMin?: number;
    /**
     * 割引上限金額：数字
     */
    discntMaxValue?: number;
    /**
     * 割引パーセント：数字
     */
    discntRate?: number;
}

